import React from "react";

export default function AccountTabs({ tab, setTab, style }) {
  return (
    <ul className={style.ul}>
      <li
        className={tab === 1 ? style.selected : style.li}
        onClick={() => setTab(1)}
      >
        Accolades
      </li>
      <li
        className={tab === 2 ? style.selected : style.li}
        onClick={() => setTab(2)}
      >
        Offers
      </li>
      <li
        className={tab === 3 ? style.selected : style.li}
        onClick={() => setTab(3)}
      >
        Profile Video Uploads
      </li>
      <li
        className={tab === 4 ? style.selected : style.li}
        onClick={() => setTab(4)}
      >
        Profile Video Links
      </li>
      <li
        className={tab === 5 ? style.selected : style.li}
        onClick={() => setTab(5)}
      >
        Weight Room
      </li>
    </ul>
  );
}
